import React from 'react';
import BiographyPage from '../components/BiographyPage/BiographyPage';

export default function Biography() {
    return (
        <div>
         <BiographyPage />
        </div>
    )
}
